// [segment, isChecked]
export const GENDERS = ['Male', 'Female'];

export const AGES = ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'];
